export const MeasurementItemWidth = 144;
export const MeasurementItemHeight = 136;
export const MeasurementItemGap = 137;
export const DashLength = 18;
export const DashWidth = 1;
export const AnimatedRectangleHeight = 43;